<template>
  <div class="doc-window">
    <div class="popup-header">
      <span class="header-text">Aadhar</span>
      <span class="close" @click="closeModal">&times;</span>
    </div>
    <div class="content">
      <div class="left-panel">
      </div>
      <div class="right-panel">
        <div class="info">
          <div class="attribute">Document Name </div>
          <div class="text">: cadarcard.pdf</div>
        </div>
        <div class="info">
          <div class="attribute">Document Type </div>
          <div class="text">: Pdf</div>
        </div>
        <div class="info">
          <div class="attribute">Upload Date </div>
          <div class="text">: 28/03/2019</div>
        </div>
        <div class="info">
          <div class="attribute">Size </div>
          <div class="text">: 5.6mb</div>
        </div>
        <div>
          <txt type="textarea" class="text-area"></txt>
        </div>
        <div class="btn-grp">
          <button class="secondary" v-on:click="cancel">Cancel</button>
          <button class="primary" v-on:click="submit">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
.doc-window {
  width: 80%;
  height: 70%;
  position: fixed;
  margin: auto;
  z-index: 5;
  background-color: white;
}
.close {
  color: #ffffff;
  float: right;
  font-size: 40px;
  font-weight: normal;
  position: absolute;
  right: 10px;
}
.content {
  padding: 16px;
  display: flex;
  height: 100%;
}
.left-panel {
  height: 85%;
  width: 65%;
  border: solid 1px #979797;
  margin-right: 16px;
}
.right-panel {
  height: 85%;
  width: 35%;
  border-left: 1px solid #979797;
  padding-left: 16px;
}

.close:hover,
.close:focus {
  color: #d8d8d8;
  text-decoration: none;
  cursor: pointer;
}
.popup-header {
  background-color: $color-secondary;
  height: 50px;
  display: flex;
  position: relative;
}
.header-text {
  color: #ffffff;
  font-weight: bold;
  font-size: 18px;
  padding: 10px 10px 10px 20px;
}
.info {
  display: flex;
}
.btn-grp {
  display: flex;
  justify-content: flex-end;
  *:nth-child(n) {
    margin-right: 16px;
  }
}
.text-area {
  margin: 20px 0px 30px 0px;
}
.secondary {
  color: $color-secondary;
  border: 1px solid $color-secondary;
  border-radius: 4px;
  background-color: white;
  width: 120px;
  height: 35px;
}
.primary {
  color: $color-white;
  background-color: $color-primary;
  border-radius: 4px;
  width: 120px;
  height: 35px;
}
.attribute {
  font-weight: bold;
  color: $color-black;
}
.text {
  color: #838383;
}
</style>
